import didServices from 'services/didServices';

export const didsActions = {
  getAllSentHistory: 'getAllSentHistory',
  getAllStatusHistory: 'getAllStatusHistory',
  updateRackZipCodeNote: 'updateRackZipCodeNote',
  getListDevice: 'getListDevice',
  getServiceCheckHistory: 'getServiceCheckHistory',
};

export default {
  [didsActions.getListDevice]: {
    saga: function*({ payload = {} }) {
      const { callbacks, body = {} } = payload;
      try {
        const listRequests = [didServices.getListDevice(body), didServices.countListDevice(body)];
        const responses = yield Promise.all(listRequests);

        const isError = responses.filter((res) => !!res?.data?.error)[0];
        if (isError) {
          callbacks && callbacks.onFailed(isError);
        } else {
          callbacks && callbacks.onSuccess(responses);
        }
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
  [didsActions.updateRackZipCodeNote]: {
    saga: function*({ payload = {} }) {
      const { callbacks, body = {} } = payload;
      try {
        const response = yield didServices.updateMonitoringDevice(body);

        const isError = response?.data?.error;
        if (isError) {
          callbacks && callbacks.onFailed(isError);
        } else {
          callbacks && callbacks.onSuccess(response);
        }
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },

  [didsActions.getAllSentHistory]: {
    saga: function*({ payload = {} }) {
      const { callbacks, filters, startDate, endDate } = payload;
      try {
        const response = yield didServices.getAllSentHistory(filters, {
          from: startDate,
          to: endDate,
        });

        const isError = response?.data?.error;
        if (isError) {
          callbacks && callbacks.onFailed(isError);
        } else {
          callbacks && callbacks.onSuccess(response);
        }
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },

  [didsActions.getAllStatusHistory]: {
    saga: function*({ payload = {} }) {
      const { callbacks, filters = {}, startDate, endDate } = payload;
      try {
        const response = yield didServices.getAllStatusHistory(filters, {
          from: startDate,
          to: endDate,
        });

        const isError = response?.data?.error;
        if (isError) {
          callbacks && callbacks.onFailed(isError);
        } else {
          callbacks && callbacks.onSuccess(response);
        }
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
  [didsActions.getServiceCheckHistory]: {
    saga: function*({ payload = {} }) {
      const { callbacks, filters = {}, startDate, endDate } = payload;
      try {
        const response = yield didServices.getAllServiceCheckHistory(filters, {
          from: startDate,
          to: endDate,
        });

        const isError = response?.data?.error;
        if (isError) {
          callbacks && callbacks.onFailed(isError);
        } else {
          callbacks && callbacks.onSuccess(response);
        }
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
